import $ from 'jquery'
import _ from 'underscore'
import config from '../config'
import messages from '../messages'
import user from '../user'
import Alert from './alert'

export default function Request(options) {
    const { url, method, data, hideError } = _.pick(options, 'url', 'method', 'data', 'hideError')
    const headers = {
        authorization: `bearer ${user.get('login_token')}`,
    }

    return new Promise((resolve, reject) => {
        $.ajax({
            url: config.get('api') + url,
            method,
            headers,
            data,
            success: (response) => {
                if (response.message) {
                    Alert(response.message)
                }

                // TODO: check data was returned here rather than everywhere
                resolve(response)
            },
            error: (error) => {
                user.set('loading', false)

                // define error message
                let errorMessage = null

                // if logout fails dont show an error
                if (url === '/api/logout') {
                    return reject(error)
                }

                switch (error.readyState) {
                    case 0:
                        if (hideError !== true) {
                            errorMessage = messages.MSG_NO_INTERNET
                        }
                        break
                    case 4:
                        // show error message
                        if (error.responseJSON && error.responseJSON.message) {
                            if (error.status === 401 && url !== '/api/login') {
                                return user.logout().catch(() => Alert(error.responseJSON.message))
                            } else if (Array.isArray(error.responseJSON.message) && error.responseJSON.message.length > 0) {
                                errorMessage = error.responseJSON.message[0].msg
                            } else if (error.responseJSON.err && error.responseJSON.err.message) {
                                errorMessage = error.responseJSON.err.message
                            } else {
                                errorMessage = error.responseJSON.message
                            }
                        } else if (error.responseText) {
                            errorMessage = error.responseText
                        } else {
                            errorMessage = messages.MSG_GENERIC_400_ERROR
                        }
                        break
                    default:
                        errorMessage = messages.MSG_NO_API_CONNECTION
                }

                // show the error message
                if (errorMessage) {
                    Alert(errorMessage)
                    return
                }

                // pass the error on
                reject(error)
            },
        })
    })
}
